// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Roboto, sans-serif, monospace;
  display: flex;
  min-height: 100vh;
}

.new-group {
  margin-top: 40px;
  margin-bottom: 5px;
}

.new-group:active {
  background-color: #8fa0ff;
}

.side-btn {
  border-radius: 10px;
  border: none;
  width: 100%;
  height: 60px;
  font-size: 1.2rem;
  font-weight: bold;
  background-color: #c6ceff;
  transition: background-color 0.2s ease-out;
}

.side-btn:hover {
  background-color: #8fa0ff;
}

.selected-group {
  background-color: #8fa0ff;
}

.group-btn {
  text-align: left;
  padding-left: 15px;
}

#all-todos {
  margin-bottom: 10px;
}

.del-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
}

.group {
  position: relative;
  margin-bottom: 10px;
}

.delete-group-btn {
  position: absolute;
  top: 50%;
  right: 2%;
  transform: translateY(-50%);
}

.delete-icon {
  width: 24px;
  height: 24px;
  fill: gray;
}

.delete-icon:hover {
  fill: red;
  cursor: pointer;
}

.delete-icon:active {
  fill: darkred;
}

#group-list {
  width: 100%;
}

.todo-card {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: lightgray;
  padding: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.todo-card:hover {
  box-shadow: 2px 2px 8px #000000;
  transform: translate(-2px, -4px);
}

#add-new-todo {
  border-radius: 10px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d3d3d335;
  transition: background-color 0.2s ease;
}

#add-new-todo:hover {
  background-color: #d3d3d350;
}

#plus-icon {
  fill: #1b1a55;
  width: 120px;
  height: 120px;
}

.delete-card-btn {
  position: absolute;
  top: 4%;
  right: 2%;
}

.todo-title {
  padding: 28px 0 5px 0;
}

.todo-desc {
  padding: 10px 0 15px 0;
}

.todo-title,
.todo-due-date,
.todo-desc {
  margin: 0;
}

#cards-container {
  width: 70vw;
  display: grid;
  grid-template-columns: repeat(auto-fit, 200px);
  grid-auto-rows: 200px;
  gap: 18px;
}

ul {
  list-style-type: none;
  padding: 0;
}

aside {
  display: flex;
  flex-direction: column;
  background-color: #070f2b;
  width: 30vw;
  align-items: center;
  padding: 0 25px 0 25px;
}

section {
  background-color: #1b1a55;
  text-align: center;
  padding: 20px 40px 20px 40px;
}

h2 {
  margin: 10px 0 40px 0;
  font-size: 2rem;
  color: lightgray;
}

#logo {
  width: 80px;
  height: auto;
}

#logo-and-heading {
  display: flex;
  align-items: center;
  justify-content: start;
  margin-top: 10px;
}

h1 {
  font-size: 2.2rem;
  font-weight: bold;
  color: lightgray;
  margin-top: 30px;
}

dialog:open {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background-color: #c6ceff;
  border-radius: 10px;
  border: none;
  padding: 12px;
  width: 380px;
  height: fit-content;
}

dialog::backdrop {
  background-color: black;
  opacity: 0.5;
}

.close-dialog {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  align-self: end;
}

.close-dialog:hover {
  color: red;
}

.close-dialog:active {
  background-color: #c6c6c6;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}

form div {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 6px;
}

form input,
select {
  width: 300px;
  font-size: 1.2rem;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #cccccc;
  box-shadow: 1px 1px 1px #999999;
  background-color: white;
}

#todo-priority {
  width: 320px;
}

form label {
  font-size: 1.2rem;
  font-weight: bold;
}

.todo-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: auto;
  margin-bottom: 5px;
}

.todo-status > label {
  font-size: 1.05rem;
  font-weight: bold;
}

.todo-status > input {
  width: 18px;
  height: 18px;
  accent-color: springgreen;
  cursor: pointer;
  border-radius: 4px;
}

#submit-group-form,
#submit-todo-form {
  width: 160px;
  height: 40px;
  border: none;
  border-radius: 5px;
  background-color: green;
  font-size: 1.2rem;
  color: white;
  margin-top: 15px;
  margin-bottom: 15px;
}

#submit-todo-form:hover,
#submit-group-form:hover {
  background-color: #009700;
}

#submit-group-form:active,
#submit-todo-form:active {
  background-color: #00a400;
}

textarea {
  padding: 10px;
  width: 300px;
  height: 100px;
  line-height: 1.5;
  border-radius: 5px;
  border: 1px solid #cccccc;
  box-shadow: 1px 1px 1px #999999;
  font-size: 1.2rem;
  resize: none;
}

.low-priority {
  background-color: #94b6d8;
}

.high-priority {
  background-color: #ccb892;
}

.is-done {
  background-color: #a6d2a7;
}

.overdue {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ","sourcesContent":["body {\n  font-family: Roboto, sans-serif, monospace;\n  display: flex;\n  min-height: 100vh;\n}\n\n.new-group {\n  margin-top: 40px;\n  margin-bottom: 5px;\n}\n\n.new-group:active {\n  background-color: #8fa0ff;\n}\n\n.side-btn {\n  border-radius: 10px;\n  border: none;\n  width: 100%;\n  height: 60px;\n  font-size: 1.2rem;\n  font-weight: bold;\n  background-color: #c6ceff;\n  transition: background-color 0.2s ease-out;\n}\n\n.side-btn:hover {\n  background-color: #8fa0ff;\n}\n\n.selected-group {\n  background-color: #8fa0ff;\n}\n\n.group-btn {\n  text-align: left;\n  padding-left: 15px;\n}\n\n#all-todos {\n  margin-bottom: 10px;\n}\n\n.del-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n.group {\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.delete-group-btn {\n  position: absolute;\n  top: 50%;\n  right: 2%;\n  transform: translateY(-50%);\n}\n\n.delete-icon {\n  width: 24px;\n  height: 24px;\n  fill: gray;\n}\n\n.delete-icon:hover {\n  fill: red;\n  cursor: pointer;\n}\n\n.delete-icon:active {\n  fill: darkred;\n}\n\n#group-list {\n  width: 100%;\n}\n\n.todo-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  background-color: lightgray;\n  padding: 12px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.todo-card:hover {\n  box-shadow: 2px 2px 8px #000000;\n  transform: translate(-2px, -4px);\n}\n\n#add-new-todo {\n  border-radius: 10px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #d3d3d335;\n  transition: background-color 0.2s ease;\n}\n\n#add-new-todo:hover {\n  background-color: #d3d3d350;\n}\n\n#plus-icon {\n  fill: #1b1a55;\n  width: 120px;\n  height: 120px;\n}\n\n.delete-card-btn {\n  position: absolute;\n  top: 4%;\n  right: 2%;\n}\n\n.todo-title {\n  padding: 28px 0 5px 0;\n}\n\n.todo-desc {\n  padding: 10px 0 15px 0;\n}\n\n.todo-title,\n.todo-due-date,\n.todo-desc {\n  margin: 0;\n}\n\n#cards-container {\n  width: 70vw;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, 200px);\n  grid-auto-rows: 200px;\n  gap: 18px;\n}\n\nul {\n  list-style-type: none;\n  padding: 0;\n}\n\naside {\n  display: flex;\n  flex-direction: column;\n  background-color: #070f2b;\n  width: 30vw;\n  align-items: center;\n  padding: 0 25px 0 25px;\n}\n\nsection {\n  background-color: #1b1a55;\n  text-align: center;\n  padding: 20px 40px 20px 40px;\n}\n\nh2 {\n  margin: 10px 0 40px 0;\n  font-size: 2rem;\n  color: lightgray;\n}\n\n#logo {\n  width: 80px;\n  height: auto;\n}\n\n#logo-and-heading {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  margin-top: 10px;\n}\n\nh1 {\n  font-size: 2.2rem;\n  font-weight: bold;\n  color: lightgray;\n  margin-top: 30px;\n}\n\ndialog:open {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  background-color: #c6ceff;\n  border-radius: 10px;\n  border: none;\n  padding: 12px;\n  width: 380px;\n  height: fit-content;\n}\n\ndialog::backdrop {\n  background-color: black;\n  opacity: 0.5;\n}\n\n.close-dialog {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: none;\n  align-self: end;\n}\n\n.close-dialog:hover {\n  color: red;\n}\n\n.close-dialog:active {\n  background-color: #c6c6c6;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 22px;\n}\n\nform div {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 6px;\n}\n\nform input,\nselect {\n  width: 300px;\n  font-size: 1.2rem;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid #cccccc;\n  box-shadow: 1px 1px 1px #999999;\n  background-color: white;\n}\n\n#todo-priority {\n  width: 320px;\n}\n\nform label {\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.todo-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: auto;\n  margin-bottom: 5px;\n}\n\n.todo-status > label {\n  font-size: 1.05rem;\n  font-weight: bold;\n}\n\n.todo-status > input {\n  width: 18px;\n  height: 18px;\n  accent-color: springgreen;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n#submit-group-form,\n#submit-todo-form {\n  width: 160px;\n  height: 40px;\n  border: none;\n  border-radius: 5px;\n  background-color: green;\n  font-size: 1.2rem;\n  color: white;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n#submit-todo-form:hover,\n#submit-group-form:hover {\n  background-color: #009700;\n}\n\n#submit-group-form:active,\n#submit-todo-form:active {\n  background-color: #00a400;\n}\n\ntextarea {\n  padding: 10px;\n  width: 300px;\n  height: 100px;\n  line-height: 1.5;\n  border-radius: 5px;\n  border: 1px solid #cccccc;\n  box-shadow: 1px 1px 1px #999999;\n  font-size: 1.2rem;\n  resize: none;\n}\n\n.low-priority {\n  background-color: #94b6d8;\n}\n\n.high-priority {\n  background-color: #ccb892;\n}\n\n.is-done {\n  background-color: #a6d2a7;\n}\n\n.overdue {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
